import { withRouter } from "react-router-dom";
import { NewProductComponent } from "./new-product.component";
import { connect } from 'react-redux'
import { Products } from "@components/product";
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import modal from '@style/modal';
import combineStyles from '~/utils/styles';

const mapStateToProps = (state, props) => ({
    table: state.products.list.table || [],
    // filter: state.catalog.list.filter || [],
    // collections: state.collections.collectionsList.collections || []
});

const actions = {
    getProductDetails: Products.actions.getProductDetails,
    updateProductGroup: Products.actions.updateProductGroup,
};

export const NewProductContainer = connect(mapStateToProps, actions)((withRouter(withStyles(combineStyles(styles, modal))(NewProductComponent))));
